import * as React from 'react';

const Auth = React.lazy(() => import('./presenter'));

export default () => <Auth />;
